import type { Config } from '../_config'

export type UseCaseResponse<T> = [Error, undefined] | [undefined, T]

export interface UseCase<Input, Output> {
  execute: Input extends undefined
    ? (params?: Input) => Promise<Output>
    : (params: Input) => Promise<Output>
}

// Define un tipo para el constructor del UseCase
export interface UseCaseConstructor<Input, Output> {
  USE_CASE_NAME: string
  create(params?: { config?: Config }): UseCase<Input, Output>
}

export class Model {}
